import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TrackCues } from '@app/core/models/Track';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface TrackCuesApi {
  intro: number;
  fadein: number;
  mix: number;
  fadeout: number;
  extro: number;
  waveform_url: string;
  playtime: number;
}

const libraryUrl = {
  getTrackCues: (idRadio: number, idTrack: number) =>
    `${environment.urls.MAIN_API_V2}/radio/${idRadio}/track/${idTrack}/cues`,
  updateTrackCues: (idRadio: number, idTrack: number) =>
    `${environment.urls.MAIN_API_V2}/radio/${idRadio}/track/${idTrack}/cues`,
  calculateTrackCues: (idRadio: number, idTrack: number) =>
    `${environment.urls.MAIN_API_V2}/radio/${idRadio}/track/${idTrack}/cues/calculate`,
};

@Injectable({
  providedIn: 'root',
})
export class TrackCuesService {
  constructor(private readonly httpClient: HttpClient) {}

  getTrackCues(idRadio: number, idTrack: number): Observable<TrackCues> {
    return this.httpClient
      .get<TrackCuesApi>(libraryUrl.getTrackCues(idRadio, idTrack))
      .pipe(map(cues => this.convertToTrackCue(cues)));
  }

  updateTrackCues(
    idRadio: number,
    idTrack: number,
    cues: TrackCues,
  ): Observable<TrackCues> {
    return this.httpClient
      .post<TrackCuesApi>(libraryUrl.updateTrackCues(idRadio, idTrack), cues)
      .pipe(map(data => this.convertToTrackCue(data)));
  }

  calculateTrackCues(idRadio: number, idTrack: number): Observable<TrackCues> {
    return this.httpClient
      .post<TrackCuesApi>(libraryUrl.calculateTrackCues(idRadio, idTrack), null)
      .pipe(map(cues => this.convertToTrackCue(cues)));
  }

  convertToTrackCue(cues: TrackCuesApi): TrackCues {
    return {
      intro: cues.intro,
      fadeIn: cues.fadein,
      mix: cues.mix,
      fadeOut: cues.fadeout,
      extro: cues.extro,
      waveformUrl: cues.waveform_url,
      playtime: cues.playtime,
    };
  }
}
